import React, { useState, useEffect } from 'react';
import HeadingArea from '../../general/HeadingArea';
import { AiOutlineSearch } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import ResponseMsg2 from '../../general/ResponseMsg2';


const CollectFee = ({ setLoading }) => {
  const [classes, setClasses] = useState([]);
  const [std, setStd] = useState([]);
  const [availableSections, setAvailableSections] = useState([]);
  const [selectedClassId, setSelectedClassId] = useState('');
  const [selectedSection, setSelectedSection] = useState('');
  const [academicYears, setAcademicYears] = useState([]);
  const [selectedAY, setSelectedAY] = useState('');
  const [selectedAYTitle, setSelectedAYTitle] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('');
  const [feeReport, setFeeReport] = useState([]);
  const [feeStr, setFeeStr] = useState([]);
  const navigate = useNavigate();

  const [response2, setResponse2] = useState({ message: '', status: 'success' });



  const fetchClasses = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-classes');
      if (response.ok) {
        const data = await response.json();
        setClasses(data);
      } else {
        console.error('Failed to fetch class');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchAcademicYears = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-academic-years');
      if (response.ok) {
        const data = await response.json();
        setAcademicYears(data);
      } else {
        console.error('Failed to fetch academic years');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };


  const fetchFeeStr = async () => {
    try {
      const response = await fetch('https://api.kcian.in/get-fee-structure');
      if (response.ok) {
        const data = await response.json();

        const filteredData = data.filter(item => {
          try {
            const classInfo = JSON.parse(item.class_id);
            return classInfo.classId == selectedClassId;
          } catch (e) {
            return false;
          }
        });

        setFeeStr(filteredData);
        return filteredData;
      }
    } catch (error) {
      console.error("Error fetching particulars:", error);
    }

    return []; // fallback
  };



  useEffect(() => {
    fetchClasses();
    fetchAcademicYears();
  }, []);


  useEffect(() => {
    if (selectedClassId) {
      const selectedClass = classes.find((cls) => cls.id === Number(selectedClassId));
      if (selectedClass && selectedClass.sections) {
        const sectionArray = selectedClass.sections
          .split(',')
          .map((s) => s.trim())
          .filter((s) => s !== '');
        setAvailableSections(sectionArray);
      } else {
        setAvailableSections([]);
      }
      setSelectedSection('');
    } else {
      setAvailableSections([]);
      setSelectedSection('');
    }
  }, [selectedClassId, classes]);

  const handleSearch = async (e) => {
    e.preventDefault();

    if (!selectedAY || !selectedClassId) {
      alert('Please select both Academic Year and Class to search.');
      return;
    }

    setLoading(true);

    try {
      // Get class_name from classId
      const selectedClass = classes.find((cls) => cls.id === Number(selectedClassId));
      const className = selectedClass ? selectedClass.class_name : '';

      // Build query params
      const params = new URLSearchParams();
      params.append('ay', selectedAY);
      params.append('class_name', className);

      if (selectedSection) {
        params.append('section', selectedSection);
      }

      const url = `https://api.kcian.in/get-student?${params.toString()}`;

      const response = await fetch(url);

      if (response.ok) {
        const data = await response.json();
        setStd(data);
        // fetchFeeReport();
      } else {
        console.error('Failed to fetch students');
      }
    } catch (error) {
      console.error('Error fetching students:', error);
    } finally {
      setLoading(false);
    }
  };


  const fetchFeeReport = async () => {
    setLoading(true);

    const params = new URLSearchParams();
    params.append('year', selectedAY);
    // params.append('std_reg', selectedMonth);

    try {
      const response = await fetch(`https://api.kcian.in/get-fee-report?${params.toString()}`);
      if (response.ok) {
        const data = await response.json();
        setFeeReport(data);


      } else {
        console.error('Failed to fetch');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };


  const handleViewReport = async (student) => {

    const classFeeStr = await fetchFeeStr();

    // Filter fee report for student
    const filteredReport = feeReport.filter(
      (r) => Number(r.std_id) == Number(student.id)
    );

    // Now navigate with fresh data
    navigate("/admin/fee-report", {
      state: {
        student,
        feeStr: classFeeStr,
        // feeReport: filteredReport,
        selectedAYTitle,
        selectedMonth,
        selectedAY,
        selectedSection,
        selectedClassId
      },
    });
  };



  return (
    <>
      <section className='py-4'>
        <div className='px-4'>
          <HeadingArea message1='Fees' message2='Collect Fees' />

          <form onSubmit={handleSearch} className='profile-card'>
            <span className="profile-heading">Select Criteria</span>

            <div className='d-md-flex d-sm-flex d-block mt-3'>
              <div className="mb-4 w-100 me-3">
                <div className='profile-input-area'>
                  <label className="profile-badge">Select AY*</label>
                  <select
                    className="profile-input"
                    value={selectedAY}
                    // onChange={(e) => setSelectedAY(e.target.value)}
                    onChange={(e) => {
                      const selectedYear = e.target.value;

                      setSelectedAY(selectedYear);

                      const ayObj = academicYears.find(
                        (ay) => ay.year === selectedYear
                      );

                      setSelectedAYTitle(ayObj?.title || '');
                    }}
                    required
                  >
                    <option value="">-- Select Academic Year --</option>
                    {academicYears.map((ay) => (
                      <option key={ay.year} value={ay.year}>
                        {ay.year} --- {ay.title}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="mb-4 w-100 me-3">
                <div className='profile-input-area'>
                  <label className="profile-badge">Select Class*</label>
                  <select
                    className="profile-input"
                    value={selectedClassId}
                    onChange={(e) => setSelectedClassId(e.target.value)}
                    required
                  >
                    <option value="">-- Select Class --</option>
                    {classes.map((cls) => (
                      <option key={cls.id} value={cls.id}>
                        {cls.class_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="mb-4 w-100 me-3">
                <div className='profile-input-area'>
                  <label className="profile-badge">Select Section*</label>
                  <select
                    className="profile-input"
                    value={selectedSection}
                    onChange={(e) => setSelectedSection(e.target.value)}
                    disabled={availableSections.length === 0}
                  >
                    <option value="">-- Select Section --</option>
                    {availableSections.map((section, idx) => (
                      <option key={idx} value={section}>
                        {section}
                      </option>
                    ))}
                  </select>
                </div>
              </div>


              {/* NEW Month Dropdown */}
              <div className="mb-4 w-100">
                <div className='profile-input-area'>
                  <label className="profile-badge">Select Month*</label>
                  <select
                    className="profile-input"
                    value={selectedMonth}
                    onChange={(e) => setSelectedMonth(e.target.value)}
                    required
                  >
                    <option value="">-- Select Month --</option>
                    <option value="January">January</option>
                    <option value="February">February</option>
                    <option value="March">March</option>
                    <option value="April">April</option>
                    <option value="May">May</option>
                    <option value="June">June</option>
                    <option value="July">July</option>
                    <option value="August">August</option>
                    <option value="September">September</option>
                    <option value="October">October</option>
                    <option value="November">November</option>
                    <option value="December">December</option>
                  </select>
                </div>
              </div>

            </div>

            <div className='text-end'>
              <button type='submit' className='profile-btn2'>
                <AiOutlineSearch /> Search
              </button>
            </div>
          </form>

          <div className='profile-card mt-4'>
            <span className="profile-heading">Student List</span>
            {/* Render student list here */}
            {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

            <div className='table-responsive mt-3'>
              <table className='w-100'>

                <thead className='account-thead'>
                  <th className='rounded-start-4'>Roll No</th>
                  <th>Reg No</th>
                  <th>Name</th>
                  <th>Father Name</th>
                  <th>DOB</th>
                  <th>Class(Section)</th>
                  <th>Gender</th>
                  <th>Mobile No</th>
                  <th className='rounded-end-4'>Activity</th>
                </thead>


                {std.length === 0 ? (
                  <tr className='text-center account-tr'><td colSpan={8}>No Student Data found</td></tr>
                ) : (
                  <>
                    {std.map((student) => (
                      <tr className='account-tr' key={student.id}>
                        <td>{student.roll_no}</td>
                        <td>{student.reg_no}</td>
                        <td>{student.name}</td>
                        <td>{student.father || '--'}</td>
                        <td>{student.dob || '--'}</td>
                        <td>{student.class_name}({student.section})</td>
                        <td>{student.gender || '--'}</td>
                        <td>{student.mobile}</td>
                        <td className='py-3 cursor-pointer'>
                          <span className='profile-btn2' onClick={() => handleViewReport(student)}>Fee Report</span>
                        </td>
                      </tr>
                    ))}
                  </>
                )}

              </table>
            </div>
            {/* table ends */}

          </div>
        </div>
      </section>


    </>
  );
};

export default CollectFee;
